import { render, staticRenderFns } from "./P2PSell.vue?vue&type=template&id=49f0b5ba&"
import script from "./P2PSell.vue?vue&type=script&lang=js&"
export * from "./P2PSell.vue?vue&type=script&lang=js&"
import style0 from "./P2PSell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports